export enum ResearchWorkflowStatus {
  Created = 'created',
  InProgress = 'in_progress',
  Completed = 'completed',
  Breaking = 'breaking',
  Broken = 'broken',
}
